// Section for import npm components -----------------------------------------------------------------------------------
import React, { useContext } from 'react';

// Material UI ( mui )  components
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

// Section for import custom components --------------------------------------------------------------------------------
import ColoredBorders from '@components/common/ColoredBorders';
import MenuContent from '@components/common/MenuContent';
import FooterNavigation from '@components/layout/Footer/FooterNavigation';
import ContactAndRequestButtons from '@components/layout/Footer/ContactAndRequestButtons';
import SocialMediaIcons from '@components/common/SocialMediaIcons';
import GrayBorder from '@components/common/GrayBorder';
import Copyright from '@components/layout/Footer/Copyright';
import FooterSP from '@components/layout/Footer/SP';

import { AppConfigContext } from '@providers/AppConfigProvider';

export default function Footer() {
  const { isMobile, pathRoot, comUrl } = useContext(AppConfigContext);
  const pathLogo: string = `${pathRoot}/assets/images/common/logo.svg`;

  return (
    <Box>
      {isMobile ? (
        <footer>
          <Box className="mb-12 max-md:mb-16">
            <ColoredBorders />
          </Box>
          <FooterSP />
        </footer>
      ) : (
        <footer>
          <Box className="mt-6 mb-14">
            <ColoredBorders />
          </Box>
          <Box className="flex flex-wrap gap-y-4 justify-between mx-24 mb-14">
            <Box className="flex items-center">
              <Link href={comUrl} className="no-underline rf-hover-element">
                <img src={pathLogo} alt="main-logo" className="w-56 h-12" />
              </Link>
            </Box>
            <ContactAndRequestButtons />
          </Box>
          <Box className="ml-24 mr-20">
            <MenuContent color="black" />
          </Box>
          <Box className="flex justify-end mx-24 mt-16 max-md:mt-10">
            <SocialMediaIcons color="black" />
          </Box>
          <GrayBorder />
          <Box className="flex justify-between  mx-24 mt-6 mb-8">
            <Box className="justify-start">
              <Copyright />
            </Box>
            <Box className="justify-end">
              <FooterNavigation />
            </Box>
          </Box>
        </footer>
      )}
    </Box>
  );
}
